export default {
  not_found_title: '404 - Page not found',
  not_found_message: 'The page you were looking for does not exist',
  not_found_button_auth: 'Back to home page',
  not_found_button: 'Log in'
};
